import { oc } from "@orpc/contract";
import { z } from "zod";

const FeedbackMetricOptionSchema = z.object({
    id: z.string(),
    text: z.string()
});
export type FeedbackMetricOption = z.infer<typeof FeedbackMetricOptionSchema>;

const FeedbackMetricOptionsSchema = z.object({
    items: z.array(FeedbackMetricOptionSchema)
});
export type FeedbackMetricOptions = z.infer<typeof FeedbackMetricOptionsSchema>;

export const feedbackCatalogContract = {
    getMetrics: oc.route({ method: "GET", path: "/metrics" }).errors({ UPSTREAM_FAILURE: {} }).output(FeedbackMetricOptionsSchema)
};
